import moment from "moment";

class bookingErros {
  constructor(
    movimId,
    booked,
    descriptionError,
    codReg,
    codRegis,
    procId,
    linea
  ) {
    this.movimId = movimId;
    this.booked = moment(booked).utc().format("DD-MM-YYYY HH:mm") + " "+ "hs";
    this.descriptionError = descriptionError;
    this.codReg = codReg;
    this.codRegis = codRegis;
    this.procId = procId;
    this.linea = linea;
  }
  static fromJson({
    MovimId,
    Fichada,
    CodErDescrip,
    CodReg,
    CodRegis,
    ProcId,
    Linea,
  }) {
    return new bookingErros(
      MovimId,
      Fichada,
      CodErDescrip,
      CodReg,
      CodRegis,
      ProcId,
      Linea
    );
  }
}
export default bookingErros;
